import React, { createContext, useState, useContext } from 'react'

// Crear el contexto
const LoadingOverlayContext = createContext()

// Crear el provider
export const LoadingOverlayProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false)

  const showLoading = () => setIsLoading(true)
  const hideLoading = () => setIsLoading(false)

  return (
    <LoadingOverlayContext.Provider
      value={{ isLoading, showLoading, hideLoading }}
    >
      {children}
    </LoadingOverlayContext.Provider>
  )
}

// Custom hook para usar el contexto
export const useLoading = () => useContext(LoadingOverlayContext)
